import React, {useState, useEffect, useMemo, useCallback} from 'react';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';

import {withData} from '../../containers/DataContainer';
import {SlotsHeader, SlotsTable} from '../../components/Tables/Slots';
import useDateInterval from '../../hooks/useDateInterval';
import useStyles from '../styles';

import SlotDetails from './Details';

const View = withData(({
  fetchSlotsByDate,
}) => {

  const classes = useStyles();

  const [path, setPath] = useState('root');
  const [isBusy, setBusy] = useState(true);
  const [startDate, setStartDate, endDate, setEndDate] = useDateInterval();

  useEffect(() => {
    const fetchData = async () => {
      setBusy(true);
      await fetchSlotsByDate({
        startDate: '' + startDate.valueOf(),
        endDate: '' + endDate.valueOf()
      });
      setBusy(false);
    };
    fetchData();
  }, [startDate, endDate, fetchSlotsByDate]);

  return <Paper className={classes.paper}>
    <Grid container>
      <Grid item xs={12}>
        <SlotsHeader
          {...{startDate, setStartDate, endDate, setEndDate}}
        />
      </Grid>
      <Grid item xs={12}>
        <Slots
          {...{
            path,
            setPath,
            isBusy
          }}
        />
      </Grid>
    </Grid>
  </Paper>;
});

export const Slots = withData(({
  data,
  path,
  setPath,
  createEvent,
  deleteSlot,
  updateSlot,
  isBusy,
  fetchData
}) => {

  const [modalData, setModalData] = useState({});

  const onRowClick = useCallback(event => {
    setModalData(event.rowData);
    setPath('detail');
  }, [setPath, setModalData]);

  const slots = useMemo(() => data.slots, [data.slots]);

  const slotsTable = useMemo(() =>
    <SlotsTable
    data={slots}
      {...{onRowClick, isBusy}}
    />, [slots, onRowClick, isBusy]
      );

  const onEvent = async data => {
    await createEvent({
      ...modalData,
      event: data
    });
    // await fetchData();
    setPath('root');
  };

  const onUpdateSlot = async data => {
    await updateSlot(data);
    await fetchData();
    setPath('root');
  };

  const onDeleteSlot = async () => {
    await deleteSlot(modalData);
    await fetchData();
    setPath('root');
  };

  return isBusy
    ? <CircularProgress/>
    : <>
    {slotsTable}
      <SlotDetails
      data={modalData}
        {...{path, setPath, onEvent, onDeleteSlot, onUpdateSlot, isBusy}}
      />
      </>;
      });

export default View;
